import { useDependencies } from '@servicetitan/react-ioc';
import { PENDO_API_TOKEN } from '../api/pendo.api';

export const usePendo = () => {
    const [pendoApi] = useDependencies(PENDO_API_TOKEN);
    return pendoApi;
};
